import { useMutation } from 'react-query';

import { request, useCurrentUserId, toastError, L2TxReqParams } from '@/utils';

import { FeedArticle, FeedArticleDetail } from '../types';
import { setQueryFeedDetailInList } from './list';
import { invalidArticleDetail } from './detail';
import { invalidArticleComments } from './comment';

// 购买收费 thread
export const useArticlePay = (id: number) => {
  const currentAddress = useCurrentUserId();

  return useMutation(
    async (tx: L2TxReqParams) => {
      return await request.post<{ article: FeedArticle }>('/article/pay', { id, tx });
    },
    {
      onSuccess() {
        const handle = (pre?: FeedArticleDetail) => {
          if (pre?.article) {
            pre.article.is_paid = true;
            pre.article.pay_count = (pre.article.pay_count || 0) + 1;
          }
        };

        setQueryFeedDetailInList(currentAddress!, id, handle);
        // 详情页需要再获取一遍 detail，才能拿到 thread 内容
        invalidArticleDetail(id, currentAddress);
        invalidArticleComments(currentAddress);
      },
      onError(err: any) {
        toastError(err || 'Failed');
      },
    },
  );
};
